import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SovosRedirectComponent } from './sovos-redirect/sovos-redirect.component';
import { SovosCallbackComponent } from './sovos-callback/sovos-callback.component';
import { LogoutAllSessionComponent } from './logout-all-session/logout-all-session.component';

@NgModule({
  declarations: [SovosRedirectComponent, SovosCallbackComponent, LogoutAllSessionComponent],
  imports: [CommonModule, MatProgressSpinnerModule],
  exports: [SovosRedirectComponent, SovosCallbackComponent, LogoutAllSessionComponent],
})
export class SovosAuthModule {}
